<template>
  <div :data-env="computeEnv" :data-pd="computePd">
    <b-navbar
      toggleable="lg"
      type="dark"
      variant="lisaweb-navbar"
    >
      <!-- <burger></burger> -->
      <!-- <span class="page-title">{{
        !pTitle ? "" : pTitle.title ? pTitle.title : pTitle.text
      }}</span> -->
      <div class="left-header" v-if="isLogged && !$store.state.sidebar.locked">
        <burger @openMenuDrawer="onOpenMenuDrawer"></burger>
        <div class="wrapper custom-header">
          <breadcrumbs :bcrumbs="clearedBreadcrumbList" />
        </div>
      </div>
      <div class="logo-wrapper" :class="{ 'is-hidden': searchOpen }">
        <svg
          class="logo"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 990 280"
          height="30"
        >
          <path
            d="M319.606,84.149c-.274-3.995.89-7.957,3.282-11.169,2.69-2.67,6.402-4.047,10.183-3.779,3.776-.237,7.475,1.136,10.183,3.779,2.487,3.226,3.66,7.274,3.282,11.33v110.041c.304,4.026-.928,8.017-3.45,11.169-2.642,2.641-6.293,4.018-10.021,3.779-3.771.205-7.458-1.163-10.183-3.779-2.461-3.177-3.631-7.166-3.276-11.169v-110.202Z"
            style="fill: #11181c"
          />
          <path
            d="M370.687,83.491c-.028-3.788,1.518-7.418,4.269-10.021,2.623-2.724,6.24-4.265,10.021-4.269,7.846-.17,14.345,6.052,14.515,13.898.17,7.846-6.052,14.345-13.898,14.515-.206.005-.411.005-.617,0-3.781-.003-7.399-1.545-10.021-4.269-2.718-2.557-4.262-6.122-4.269-9.854ZM398.442,194.358c.304,4.026-.928,8.017-3.45,11.169-2.642,2.641-6.293,4.018-10.021,3.779-3.771.205-7.458-1.163-10.183-3.779-2.463-3.176-3.635-7.166-3.282-11.169v-74.238c-.27-4.045.892-8.056,3.282-11.33,2.647-2.736,6.391-4.125,10.183-3.779,3.776-.237,7.475,1.136,10.183,3.779,2.438,3.251,3.605,7.28,3.282,11.33v74.238h.007Z"
            style="fill: #11181c"
          />
          <path
            d="M454.61,167.086c-9.815-1.634-19.102-5.575-27.097-11.498-5.358-4.774-8.259-11.722-7.887-18.888-.316-9.457,3.818-18.515,11.169-24.473,8.704-6.447,19.391-9.644,30.205-9.035,9.705-.315,19.325,1.891,27.923,6.404,6.395,2.586,10.781,8.562,11.33,15.438.101,2.932-1.101,5.758-3.282,7.719-2.157,2.08-5.06,3.205-8.055,3.121-4.749-.757-9.157-2.933-12.646-6.242l-2.135-1.644c-1.807-1.345-3.877-2.296-6.075-2.792-2.338-.744-4.775-1.131-7.229-1.148-3.913-.233-7.819.561-11.33,2.302-2.424,1.51-3.857,4.2-3.759,7.055.043,2.393,1.358,4.583,3.45,5.746,5.044,2.22,10.338,3.82,15.767,4.766l8.377,1.806c9.738,1.428,18.983,5.204,26.936,11.001,5.336,4.916,8.172,11.976,7.719,19.217.59,10.194-3.976,20.004-12.156,26.117-10.466,6.65-22.77,9.813-35.145,9.035-10.386.37-20.672-2.132-29.729-7.229-6.852-3.263-11.384-9.997-11.827-17.573-.203-6.51,4.909-11.953,11.419-12.156.245-.008.491-.008.736,0,4.827.535,9.222,3.03,12.156,6.9l2.624,2.953c2.072,2.123,4.595,3.752,7.383,4.766,3.449,1.09,7.057,1.589,10.672,1.477,4.268.251,8.524-.658,12.317-2.631,2.7-1.461,4.35-4.315,4.269-7.384,0-4.269-5.256-7.558-15.606-10.183-.178.009-.352-.049-.49-.161l-10.008-2.786Z"
            style="fill: #11181c"
          />
          <path
            d="M609.328,131.611v60.934c.066,1.162.23,2.316.49,3.45l.49,4.927c.127,2.857-1.015,5.624-3.121,7.558-2.398,1.963-5.443,2.959-8.538,2.792-4.111.313-8.164-1.117-11.169-3.94-2.694-3.451-3.984-7.793-3.611-12.156-3.313,5.088-7.899,9.222-13.304,11.988-5.983,2.91-12.565,4.372-19.217,4.269-8.314.497-16.46-2.481-22.493-8.223-5.655-6.342-8.553-14.675-8.055-23.157-.49-7.704,1.902-15.314,6.712-21.352,6.375-5.883,14.402-9.667,22.996-10.84,3.45-.671,8.538-1.477,15.438-2.302,4.272-.323,8.505-1.037,12.646-2.134,1.484-.509,2.719-1.565,3.45-2.953.706-1.544,1.043-3.23.987-4.927.333-3.366-1.096-6.666-3.779-8.726-3.865-2.102-8.264-3.015-12.646-2.624-1.484.015-2.966.125-4.437.329-1.399.191-2.775.522-4.108.987-2.484.76-4.774,2.049-6.712,3.779l-3.121,3.121c-2.872,3.857-7.211,6.354-11.988,6.9-2.903.122-5.717-1.016-7.719-3.121-2.086-2.081-3.216-4.935-3.121-7.88.528-7.499,4.955-14.171,11.659-17.573,8.575-5.278,18.518-7.907,28.581-7.558,11.249-.668,22.459,1.836,32.353,7.229,7.384,4.452,11.735,12.591,11.337,21.204ZM583.539,158.058c-4.922,2.13-10.038,3.78-15.277,4.927-2.988.501-5.948,1.16-8.867,1.973-3.679.793-7.08,2.552-9.854,5.095-1.938,2.349-2.933,5.335-2.792,8.377-.145,3.375,1.244,6.634,3.779,8.867,2.934,2.321,6.615,3.488,10.35,3.282,6.101.273,12.045-1.986,16.425-6.242,4.267-4.518,6.519-10.573,6.242-16.781l-.007-9.498Z"
            style="fill: #11181c"
          />
          <path
            d="M680.78,195.17c-.453,4.142-2.174,8.042-4.927,11.169-3.526,2.212-7.684,3.194-11.827,2.792-3.861.416-7.747-.514-11.001-2.631-2.911-3.228-4.847-7.215-5.585-11.498l-19.687-70.452-.987-3.94-.329-3.121c-.082-3.476,1.217-6.843,3.611-9.364,2.402-2.489,5.737-3.86,9.196-3.779,3.103-.158,6.134.971,8.377,3.121,2.418,2.558,4.07,5.745,4.766,9.196l13.962,59.786,11.33-57.652c.469-4.217,2.251-8.181,5.095-11.33,3.234-2.335,7.194-3.441,11.169-3.121,2.257-.079,4.515.146,6.712.671,1.657.36,3.189,1.154,4.437,2.302,2.806,3.257,4.629,7.245,5.256,11.498l12.156,57.484,13.962-59.947c.75-3.3,2.333-6.353,4.598-8.867,2.115-2.035,4.946-3.156,7.88-3.121,3.382-.189,6.698.994,9.196,3.282,2.259,2.384,3.444,5.587,3.282,8.867l-.329,2.953c-.055.666-.165,1.326-.329,1.973-.146.84-.371,1.665-.671,2.463l-19.875,70.956c-.739,4.233-2.677,8.166-5.585,11.33-6.864,3.724-15.146,3.724-22.01,0-2.844-3.167-4.675-7.113-5.256-11.33l-13.794-59.947-12.794,60.255Z"
            style="fill: var(--lisaweb)"
          />
          <path
            d="M800.997,164.293c-.096,3.522.462,7.031,1.644,10.35.914,2.859,2.427,5.49,4.437,7.719,1.838,2.087,4.136,3.718,6.712,4.766,2.886,1.094,5.948,1.652,9.035,1.644,1.484-.015,2.967-.125,4.437-.329,1.399-.191,2.775-.521,4.108-.987,2.526-.794,4.871-2.078,6.9-3.779l1.973-1.806c3.155-3.403,7.391-5.609,11.988-6.242,2.815-.079,5.542.987,7.558,2.953,2.033,1.848,3.17,4.482,3.121,7.229-.021,2.185-.586,4.331-1.644,6.242-1.268,2.398-2.934,4.563-4.927,6.404-4.526,4.13-9.832,7.314-15.606,9.364-6.425,2.298-13.214,3.41-20.036,3.282-13.156.55-25.869-4.813-34.655-14.619-9.024-11.216-13.587-25.369-12.814-39.743-.755-14.145,3.749-28.07,12.646-39.092,8.768-9.698,21.43-14.944,34.488-14.29,13.081-.615,25.824,4.267,35.145,13.465,9.037,9.801,13.771,22.815,13.143,36.132.358,3.266-.521,6.547-2.463,9.196-3.604,2.149-7.829,3.017-11.988,2.463h-53.215l.013-.322ZM840.74,146.56c.063-2.976-.438-5.937-1.477-8.726-.913-2.487-2.309-4.768-4.108-6.712-3.83-3.774-9.084-5.744-14.452-5.417-5.213-.267-10.293,1.704-13.961,5.417-1.883,1.909-3.338,4.197-4.269,6.712-1.079,2.832-1.636,5.836-1.644,8.867h39.911v-.141Z"
            style="fill: var(--lisaweb)"
          />
          <path
            d="M912.682,196.975c.162,3.33-1.021,6.585-3.282,9.035-2.497,2.289-5.813,3.473-9.196,3.282-3.728.239-7.379-1.137-10.021-3.779-2.392-3.212-3.556-7.174-3.282-11.169v-110.202c-.296-4.048.869-8.068,3.282-11.33,5.608-5.024,14.099-5.024,19.707,0,2.414,3.263,3.578,7.283,3.282,11.33v35.145c3.055-5.069,7.428-9.215,12.653-11.995,5.294-2.669,11.154-4.02,17.083-3.94,11.825-.111,22.968,5.522,29.89,15.109,8.149,11.36,12.254,25.124,11.659,39.092.623,13.87-3.488,27.539-11.659,38.763-7.085,9.504-18.356,14.959-30.205,14.619-5.908.205-11.759-1.216-16.915-4.108-5.295-3.232-9.743-7.68-12.975-12.975l-.02,3.121ZM935.84,126.678c-6.6-.344-12.921,2.69-16.781,8.055-7.664,14.137-7.664,31.191,0,45.328,3.9,5.173,10.117,8.066,16.586,7.719,6.452.329,12.61-2.723,16.257-8.055,4.292-6.928,6.301-15.027,5.746-23.157.41-7.725-1.662-15.379-5.914-21.842-3.557-5.243-9.564-8.282-15.895-8.041v-.007Z"
            style="fill: var(--lisaweb)"
          />
          <circle
            cx="138.722"
            cy="140"
            r="133.241"
            style="fill: var(--lisaweb)"
          />
          <path
            d="M191.626,215.426h-91.926c-12.263,0-22.205-9.942-22.205-22.205v-116.282c0-12.263,9.941-22.205,22.205-22.205s22.205,9.941,22.205,22.205v94.077h69.721c12.263,0,22.205,9.942,22.205,22.205s-9.942,22.205-22.205,22.205Z"
            style="fill: #fff"
          />
        </svg>
        <template v-if="computePd === 'true'">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            viewBox="0 0 122.878 122.88"
          >
            <path
              d="M1.426,8.313c-1.901-1.901-1.901-4.984,0-6.886c1.901-1.902,4.984-1.902,6.886,0l53.127,53.127l53.127-53.127 c1.901-1.902,4.984-1.902,6.887,0c1.901,1.901,1.901,4.985,0,6.886L68.324,61.439l53.128,53.128c1.901,1.901,1.901,4.984,0,6.886 c-1.902,1.902-4.985,1.902-6.887,0L61.438,68.326L8.312,121.453c-1.901,1.902-4.984,1.902-6.886,0 c-1.901-1.901-1.901-4.984,0-6.886l53.127-53.128L1.426,8.313L1.426,8.313z"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30"
            viewBox="0 0 111.255 45"
          >
            <path
              d="M78.203 27.9c0-8.88 6.719-15.899 16.019-15.899s16.02 7.02 16.02 15.899-6.72 15.899-16.02 15.899-16.019-7.02-16.019-15.899zm23.305 2.314c1.085-4.93-2.093-9.615-6.863-9.666-3.395-.036-6.331 2.478-7.073 5.791-1.106 4.937 2.16 9.628 6.945 9.66 3.372.023 6.266-2.492 6.991-5.785z"
              fill-opacity=".5"
              opacity=".7"
            />
            <g fill="var(--lisaweb)">
              <path
                d="M40.013,5.284c0-2.275,1.886-4.083,4.26-4.083s4.26,1.808,4.26,4.083v33.832c0,2.275-1.886,4.083-4.26,4.083s-4.26-1.808-4.26-4.083V5.284Z"
                fill-opacity=".5"
              />
              <path
                d="M15.814 27.562c0-9.068 6.862-16.237 16.36-16.237s16.359 7.169 16.359 16.237-6.862 16.237-16.359 16.237-16.36-7.169-16.36-16.237zm24.168.343c0-4.374-3.116-8.09-7.49-8.09s-7.551 3.715-7.551 8.09 3.176 8.09 7.551 8.09 7.49-3.715 7.49-8.09z"
                fill-opacity=".5"
              />
            </g>
            <circle cx="102.113" cy="19.138" r="4.321" fill="#121922" />
            <g fill="var(--lisaweb)">
              <path
                d="M15.799 1.201H5.72c-2.46 0-4.5 2.039-4.5 4.499v33.599c0 2.46 2.04 4.5 4.5 4.5s4.5-2.04 4.5-4.5V27.585h5.58c8.157 0 13.795-5.936 13.799-13.192C29.595 7.137 23.957 1.201 15.8 1.201h-.001zm-.3 17.985h-5.28V9.601h5.28c2.637 0 4.795 2.156 4.799 4.793-.004 2.636-2.162 4.793-4.799 4.793h0z"
                fill-opacity=".5"
              />
              <circle cx="26.503" cy="38.412" r="4.104" />
              <path
                d="M29.598,14.371c0-.969-.109-1.911-.302-2.822-7.971,1.29-13.482,7.87-13.482,15.991,0,.007.001.015.001.022,8.148-.008,13.78-5.94,13.783-13.191Z"
              />
            </g>
            <path
              d="M87.549,26.503c.005-.022.006-.044.011-.065.257-1.36.392-2.768.392-4.214,0-2.952-.557-5.749-1.593-8.285-4.991,2.674-8.156,7.891-8.156,13.985,0,3.686,1.171,7.041,3.191,9.717,3.154-2.906,5.311-6.753,6.155-11.137h0Z"
              fill="#121922"
            />
            <path
              d="M66.262 1.201h-6.318c-.01 0-.02-.003-.03-.003A4.2 4.2 0 0 0 55.8 4.56c-.076.302-.127.613-.136.937h-.007v.072c0 .016-.005.03-.005.046s.004.03.005.046v10.343c0 .016.005.031.005.048l-.004.043c.003.507.1.986.256 1.434.025.071.038.148.068.218.015.037.038.069.055.106.66 1.455 2.117 2.471 3.819 2.471.052 0 .1-.013.151-.015s.098.015.15.015a3.9 3.9 0 0 0 3.899-3.899V9.6h2.207c7.739 0 12.359 5.58 12.359 12.6s-4.62 12.6-12.359 12.6H52.626v8.399h13.637c12.959 0 21.659-9.3 21.659-20.999S79.221 1.201 66.262 1.201z"
              fill-opacity=".5"
              opacity=".7"
            />
            <path
              d="M55.358,34.787h-8.45c1.038-2.171,1.624-4.617,1.624-7.229,0-6.299-3.315-11.674-8.52-14.374l-.014,25.802c0,2.339,1.782,4.199,4.025,4.199h11.335c2.242,0,4.025-1.859,4.025-4.199s-1.782-4.199-4.025-4.199Z"
              fill="var(--lisaweb)"
            />
          </svg>
        </template>
      </div>
      <b-navbar-nav class="ml-auto actions" style="align-items: center">
        <!-- <b-nav-text
          >Agenzia: <b>{{ settings.formatted_title }}</b>
        </b-nav-text> -->
        <!-- Ricerca: un'icona che al click apre una barra larga al centro
             della testata, al posto del logo; si richiude cliccando fuori o
             con Esc. -->
        <li
          v-if="canVerb('tags', 'index')"
          ref="headerSearch"
          class="nav-item header-search"
          @keydown.esc="searchOpen = false"
        >
          <button
            type="button"
            class="header-search__toggle"
            :class="{ 'is-hidden': searchOpen }"
            title="Cerca"
            @click="openSearch"
          >
            <b-icon icon="search"></b-icon>
          </button>
          <!-- duration: l'entrata dura quanto il suggerimento, che
               compare dopo la barra. -->
          <transition
            name="header-search"
            :duration="{ enter: 300, leave: 150 }"
          >
            <div v-show="searchOpen" class="header-search__panel">
              <b-overlay class="search-bar-wrapper" :show="isLoading">
                <form class="form-inline" @submit.prevent="">
                  <b-input-group
                    size="sm"
                    class="search-bar"
                    :style="{ 'background-color': isLoading ? 'grey' : 'inherit' }"
                  >
                    <b-form-input
                      ref="searchInput"
                      autocomplete="off"
                      type="search"
                      placeholder="Inserisci un criterio di ricerca"
                      size="sm"
                      v-model="something"
                      @keypress="getSomething"
                      :disabled="isLoading"
                      :title="isLoading ? 'Ricerca in corso...' : ''"
                    >
                    </b-form-input>
                    <b-input-group-append
                      is-text
                      class="search-bar-icon"
                      :class="`search-bar-icon${!isLoading ? ' is-loading' : ''}`"
                      :title="isLoading ? 'Ricerca in corso...' : 'Cerca'"
                    >
                      <b-icon icon="search" @click="!isLoading && onFind()"></b-icon>
                    </b-input-group-append>
                  </b-input-group>
                </form>
                <template #overlay>
                  <div class="text-center">
                    <div class="custom-loader custom-loader--small"></div>
                  </div>
                </template>
              </b-overlay>
              <p class="header-search__hint">Invio per cercare · Esc per chiudere</p>
            </div>
          </transition>
        </li>
        <template v-if="showLisawebSwitch">
          <b-nav-text>
            <span
              class="lisapay-carts"
              href="#"
              style="align-items: center"
              role="button"
              tabindex="0"
              @click="switchLisaweb(codeAgency)"
            >
              Usa la vecchia interfaccia
              <svg
                class="logo"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 990 280"
                height="18"
              >
                <path
                  d="M319.606,84.149c-.274-3.995.89-7.957,3.282-11.169,2.69-2.67,6.402-4.047,10.183-3.779,3.776-.237,7.475,1.136,10.183,3.779,2.487,3.226,3.66,7.274,3.282,11.33v110.041c.304,4.026-.928,8.017-3.45,11.169-2.642,2.641-6.293,4.018-10.021,3.779-3.771.205-7.458-1.163-10.183-3.779-2.461-3.177-3.631-7.166-3.276-11.169v-110.202Z"
                  style="fill: #584a35"
                />
                <path
                  d="M370.687,83.491c-.028-3.788,1.518-7.418,4.269-10.021,2.623-2.724,6.24-4.265,10.021-4.269,7.846-.17,14.345,6.052,14.515,13.898.17,7.846-6.052,14.345-13.898,14.515-.206.005-.411.005-.617,0-3.781-.003-7.399-1.545-10.021-4.269-2.718-2.557-4.262-6.122-4.269-9.854ZM398.442,194.358c.304,4.026-.928,8.017-3.45,11.169-2.642,2.641-6.293,4.018-10.021,3.779-3.771.205-7.458-1.163-10.183-3.779-2.463-3.176-3.635-7.166-3.282-11.169v-74.238c-.27-4.045.892-8.056,3.282-11.33,2.647-2.736,6.391-4.125,10.183-3.779,3.776-.237,7.475,1.136,10.183,3.779,2.438,3.251,3.605,7.28,3.282,11.33v74.238h.007Z"
                  style="fill: #584a35"
                />
                <path
                  d="M454.61,167.086c-9.815-1.634-19.102-5.575-27.097-11.498-5.358-4.774-8.259-11.722-7.887-18.888-.316-9.457,3.818-18.515,11.169-24.473,8.704-6.447,19.391-9.644,30.205-9.035,9.705-.315,19.325,1.891,27.923,6.404,6.395,2.586,10.781,8.562,11.33,15.438.101,2.932-1.101,5.758-3.282,7.719-2.157,2.08-5.06,3.205-8.055,3.121-4.749-.757-9.157-2.933-12.646-6.242l-2.135-1.644c-1.807-1.345-3.877-2.296-6.075-2.792-2.338-.744-4.775-1.131-7.229-1.148-3.913-.233-7.819.561-11.33,2.302-2.424,1.51-3.857,4.2-3.759,7.055.043,2.393,1.358,4.583,3.45,5.746,5.044,2.22,10.338,3.82,15.767,4.766l8.377,1.806c9.738,1.428,18.983,5.204,26.936,11.001,5.336,4.916,8.172,11.976,7.719,19.217.59,10.194-3.976,20.004-12.156,26.117-10.466,6.65-22.77,9.813-35.145,9.035-10.386.37-20.672-2.132-29.729-7.229-6.852-3.263-11.384-9.997-11.827-17.573-.203-6.51,4.909-11.953,11.419-12.156.245-.008.491-.008.736,0,4.827.535,9.222,3.03,12.156,6.9l2.624,2.953c2.072,2.123,4.595,3.752,7.383,4.766,3.449,1.09,7.057,1.589,10.672,1.477,4.268.251,8.524-.658,12.317-2.631,2.7-1.461,4.35-4.315,4.269-7.384,0-4.269-5.256-7.558-15.606-10.183-.178.009-.352-.049-.49-.161l-10.008-2.786Z"
                  style="fill: #584a35"
                />
                <path
                  d="M609.328,131.611v60.934c.066,1.162.23,2.316.49,3.45l.49,4.927c.127,2.857-1.015,5.624-3.121,7.558-2.398,1.963-5.443,2.959-8.538,2.792-4.111.313-8.164-1.117-11.169-3.94-2.694-3.451-3.984-7.793-3.611-12.156-3.313,5.088-7.899,9.222-13.304,11.988-5.983,2.91-12.565,4.372-19.217,4.269-8.314.497-16.46-2.481-22.493-8.223-5.655-6.342-8.553-14.675-8.055-23.157-.49-7.704,1.902-15.314,6.712-21.352,6.375-5.883,14.402-9.667,22.996-10.84,3.45-.671,8.538-1.477,15.438-2.302,4.272-.323,8.505-1.037,12.646-2.134,1.484-.509,2.719-1.565,3.45-2.953.706-1.544,1.043-3.23.987-4.927.333-3.366-1.096-6.666-3.779-8.726-3.865-2.102-8.264-3.015-12.646-2.624-1.484.015-2.966.125-4.437.329-1.399.191-2.775.522-4.108.987-2.484.76-4.774,2.049-6.712,3.779l-3.121,3.121c-2.872,3.857-7.211,6.354-11.988,6.9-2.903.122-5.717-1.016-7.719-3.121-2.086-2.081-3.216-4.935-3.121-7.88.528-7.499,4.955-14.171,11.659-17.573,8.575-5.278,18.518-7.907,28.581-7.558,11.249-.668,22.459,1.836,32.353,7.229,7.384,4.452,11.735,12.591,11.337,21.204ZM583.539,158.058c-4.922,2.13-10.038,3.78-15.277,4.927-2.988.501-5.948,1.16-8.867,1.973-3.679.793-7.08,2.552-9.854,5.095-1.938,2.349-2.933,5.335-2.792,8.377-.145,3.375,1.244,6.634,3.779,8.867,2.934,2.321,6.615,3.488,10.35,3.282,6.101.273,12.045-1.986,16.425-6.242,4.267-4.518,6.519-10.573,6.242-16.781l-.007-9.498Z"
                  style="fill: #584a35"
                />
                <path
                  d="M680.78,195.17c-.453,4.142-2.174,8.042-4.927,11.169-3.526,2.212-7.684,3.194-11.827,2.792-3.861.416-7.747-.514-11.001-2.631-2.911-3.228-4.847-7.215-5.585-11.498l-19.687-70.452-.987-3.94-.329-3.121c-.082-3.476,1.217-6.843,3.611-9.364,2.402-2.489,5.737-3.86,9.196-3.779,3.103-.158,6.134.971,8.377,3.121,2.418,2.558,4.07,5.745,4.766,9.196l13.962,59.786,11.33-57.652c.469-4.217,2.251-8.181,5.095-11.33,3.234-2.335,7.194-3.441,11.169-3.121,2.257-.079,4.515.146,6.712.671,1.657.36,3.189,1.154,4.437,2.302,2.806,3.257,4.629,7.245,5.256,11.498l12.156,57.484,13.962-59.947c.75-3.3,2.333-6.353,4.598-8.867,2.115-2.035,4.946-3.156,7.88-3.121,3.382-.189,6.698.994,9.196,3.282,2.259,2.384,3.444,5.587,3.282,8.867l-.329,2.953c-.055.666-.165,1.326-.329,1.973-.146.84-.371,1.665-.671,2.463l-19.875,70.956c-.739,4.233-2.677,8.166-5.585,11.33-6.864,3.724-15.146,3.724-22.01,0-2.844-3.167-4.675-7.113-5.256-11.33l-13.794-59.947-12.794,60.255Z"
                  style="fill: #f49702"
                />
                <path
                  d="M800.997,164.293c-.096,3.522.462,7.031,1.644,10.35.914,2.859,2.427,5.49,4.437,7.719,1.838,2.087,4.136,3.718,6.712,4.766,2.886,1.094,5.948,1.652,9.035,1.644,1.484-.015,2.967-.125,4.437-.329,1.399-.191,2.775-.521,4.108-.987,2.526-.794,4.871-2.078,6.9-3.779l1.973-1.806c3.155-3.403,7.391-5.609,11.988-6.242,2.815-.079,5.542.987,7.558,2.953,2.033,1.848,3.17,4.482,3.121,7.229-.021,2.185-.586,4.331-1.644,6.242-1.268,2.398-2.934,4.563-4.927,6.404-4.526,4.13-9.832,7.314-15.606,9.364-6.425,2.298-13.214,3.41-20.036,3.282-13.156.55-25.869-4.813-34.655-14.619-9.024-11.216-13.587-25.369-12.814-39.743-.755-14.145,3.749-28.07,12.646-39.092,8.768-9.698,21.43-14.944,34.488-14.29,13.081-.615,25.824,4.267,35.145,13.465,9.037,9.801,13.771,22.815,13.143,36.132.358,3.266-.521,6.547-2.463,9.196-3.604,2.149-7.829,3.017-11.988,2.463h-53.215l.013-.322ZM840.74,146.56c.063-2.976-.438-5.937-1.477-8.726-.913-2.487-2.309-4.768-4.108-6.712-3.83-3.774-9.084-5.744-14.452-5.417-5.213-.267-10.293,1.704-13.961,5.417-1.883,1.909-3.338,4.197-4.269,6.712-1.079,2.832-1.636,5.836-1.644,8.867h39.911v-.141Z"
                  style="fill: #f49702"
                />
                <path
                  d="M912.682,196.975c.162,3.33-1.021,6.585-3.282,9.035-2.497,2.289-5.813,3.473-9.196,3.282-3.728.239-7.379-1.137-10.021-3.779-2.392-3.212-3.556-7.174-3.282-11.169v-110.202c-.296-4.048.869-8.068,3.282-11.33,5.608-5.024,14.099-5.024,19.707,0,2.414,3.263,3.578,7.283,3.282,11.33v35.145c3.055-5.069,7.428-9.215,12.653-11.995,5.294-2.669,11.154-4.02,17.083-3.94,11.825-.111,22.968,5.522,29.89,15.109,8.149,11.36,12.254,25.124,11.659,39.092.623,13.87-3.488,27.539-11.659,38.763-7.085,9.504-18.356,14.959-30.205,14.619-5.908.205-11.759-1.216-16.915-4.108-5.295-3.232-9.743-7.68-12.975-12.975l-.02,3.121ZM935.84,126.678c-6.6-.344-12.921,2.69-16.781,8.055-7.664,14.137-7.664,31.191,0,45.328,3.9,5.173,10.117,8.066,16.586,7.719,6.452.329,12.61-2.723,16.257-8.055,4.292-6.928,6.301-15.027,5.746-23.157.41-7.725-1.662-15.379-5.914-21.842-3.557-5.243-9.564-8.282-15.895-8.041v-.007Z"
                  style="fill: #f49702"
                />
                <circle
                  cx="138.722"
                  cy="140"
                  r="133.241"
                  style="fill: #f49702"
                />
                <path
                  d="M191.626,215.426h-91.926c-12.263,0-22.205-9.942-22.205-22.205v-116.282c0-12.263,9.941-22.205,22.205-22.205s22.205,9.941,22.205,22.205v94.077h69.721c12.263,0,22.205,9.942,22.205,22.205s-9.942,22.205-22.205,22.205Z"
                  style="fill: #fff"
                />
              </svg>
            </span>
          </b-nav-text>
        </template>
        <template
          v-if="$store.state.auth.settings.attributables.LISAPAY === 'Y'"
        >
          <b-nav-text>
            <span
              class="lisapay-carts"
              title="Apri i carrelli di Lisapay in una nuova finestra"
              href="#"
              role="button"
              tabindex="0"
              @click="openLisaPay()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 934.7 266.5"
                height="18"
              >
                <g fill="#23469d">
                  <path
                    d="M133.2 0C59.7 0 0 59.7 0 133.2s59.7 133.2 133.2 133.2 133.2-59.7 133.2-133.2S206.8 0 133.2 0zm52.9 208.7H94.2c-12.2 0-22.2-9.9-22.2-22.1h0V70.2C72 57.9 82 48 94.2 48s22.2 9.9 22.2 22.1h0v94.2h69.7c12.2 0 22.2 9.9 22.2 22.1v.1c0 12.2-9.9 22.2-22.2 22.2h0zm141.34-7.9c-8.89 0-13.34-3.38-13.34-10.14V78.72c0-7.26 4.51-10.9 13.53-10.9 3.26 0 6.17.79 8.74 2.35 2.56 1.57 3.84 4.17 3.84 7.8V190.3c0 3.75-1.12 6.45-3.38 8.08-2.25 1.62-5.39 2.44-9.39 2.44zm52.4-137.5c3.63 0 6.98 1.13 10.05 3.39 3.06 2.25 4.6 5.76 4.6 10.52 0 4.26-1.35 7.64-4.04 10.14-2.7 2.51-6.23 3.76-10.62 3.76s-7.92-1.25-10.61-3.76c-2.7-2.5-4.04-5.88-4.04-10.14 0-4 1.35-7.32 4.04-9.96 2.69-2.63 6.23-3.94 10.61-3.94zm0 137.5c-8.89 0-13.34-3.38-13.34-10.14v-77.2c0-3.63 1.06-6.51 3.19-8.64s5.57-3.19 10.33-3.19c4 0 7.1.88 9.29 2.63 2.19 1.76 3.29 4.45 3.29 8.08v77.95c0 3.75-1.12 6.45-3.38 8.08-2.25 1.62-5.39 2.44-9.39 2.44zm115.52-29.68c0 10.52-3.82 18.4-11.46 23.67-7.64 5.26-18.04 7.89-31.18 7.89-7.51 0-14.25-.88-20.19-2.63-5.95-1.76-10.74-3.94-14.37-6.57-1.63-1.13-2.85-2.42-3.66-3.85-.82-1.44-1.22-2.85-1.22-4.23 0-2.51.63-4.88 1.88-7.14 1-1.88 2.29-3.45 3.85-4.69 1.56-1.25 3.41-1.88 5.54-1.88 1.87 0 3.69.56 5.44 1.69l5.92 3.75c2.19 1.38 4.73 2.64 7.61 3.76 2.87 1.12 6.5 1.69 10.89 1.69 5.38 0 9.26-.87 11.65-2.63 2.38-1.75 3.57-4.13 3.57-7.14 0-2.25-.85-4.32-2.54-6.2s-5.17-3.26-10.42-4.13l-11.27-1.88c-4.64-.76-8.87-1.85-12.68-3.29-3.82-1.44-7.11-3.32-9.87-5.64a23.65 23.65 0 0 1-6.38-8.45c-1.51-3.31-2.25-7.35-2.25-12.11 0-5.01 1-9.45 3-13.34 2-3.87 4.82-7.16 8.45-9.86 3.63-2.69 7.99-4.72 13.05-6.11 5.07-1.38 10.62-2.06 16.62-2.06 8.77 0 15.9 1.03 21.42 3.1 5.5 2.06 9.58 4.17 12.21 6.29 1.63 1.38 2.75 2.76 3.39 4.13.62 1.38.93 2.75.93 4.13 0 3.01-.81 5.58-2.44 7.7-1 1.25-2.04 2.22-3.1 2.91s-2.41 1.03-4.04 1.03c-1.38 0-2.79-.28-4.23-.85-1.44-.56-2.66-1.15-3.66-1.78-3.39-2-6.64-3.63-9.77-4.88s-7.2-1.88-12.21-1.88-8.48.85-10.8 2.54-3.47 3.79-3.47 6.29c0 2.25.84 4.23 2.53 5.92s5.36 3.04 10.99 4.04l9.96 1.88c11.39 2.12 19.63 5.51 24.69 10.14 5.07 4.63 7.61 11.52 7.61 20.66z"
                  ></path>
                  <use xlink:href="#B"></use>
                  <path
                    d="M623.64 112.52c0-3.26 1.06-5.95 3.19-8.07 2.13-2.13 5.57-3.19 10.33-3.19 3.13 0 5.98.66 8.54 1.97s3.85 3.91 3.85 7.8v3.57c1-1.51 2.35-3.13 4.04-4.88 1.69-1.76 3.72-3.39 6.11-4.88 2.38-1.51 5.07-2.73 8.08-3.67 3-.93 6.38-1.41 10.14-1.41 6.76 0 12.71 1.28 17.85 3.85 5.13 2.57 9.42 6.14 12.86 10.71s6.01 9.99 7.7 16.25 2.53 13.08 2.53 20.47-.97 14.44-2.91 20.76c-1.94 6.33-4.75 11.77-8.45 16.34s-8.24 8.14-13.62 10.71c-5.39 2.57-11.53 3.85-18.41 3.85-5.01 0-9.17-.6-12.49-1.79s-6.05-2.53-8.17-4.04c-2.38-1.63-4.32-3.57-5.82-5.82v37.56c0 3.88-1 6.67-3 8.36s-5.33 2.54-9.96 2.54c-8.26 0-12.4-3.45-12.4-10.33V112.53zm68.57 38.88c0-4.26-.47-8.2-1.41-11.84-.94-3.63-2.32-6.79-4.13-9.48-1.82-2.69-4.07-4.79-6.76-6.29-2.7-1.51-5.79-2.25-9.3-2.25s-6.79.75-9.48 2.25-4.98 3.6-6.86 6.29c-1.88 2.7-3.29 5.85-4.23 9.48-.94 3.64-1.41 7.58-1.41 11.84 0 9.14 1.88 16.4 5.63 21.78 3.76 5.39 9.2 8.08 16.34 8.08s12.52-2.82 16.16-8.45c3.63-5.63 5.45-12.77 5.45-21.41z"
                  ></path>
                  <use xlink:href="#B" x="225.22"></use>
                  <path
                    d="M872.89 193.85l-33.06-74.2c-.88-1.88-1.38-3.38-1.51-4.51l-.19-3c0-3.26 1.28-5.82 3.85-7.7s6.05-2.82 10.42-2.82c3.76 0 6.54.72 8.36 2.16 1.81 1.44 3.23 3.41 4.23 5.92l21.6 54.65 22.73-54.47c1.25-2.87 2.72-4.98 4.41-6.29 1.7-1.31 4.17-1.97 7.42-1.97 4.38 0 7.7 1.03 9.96 3.1 2.25 2.07 3.38 4.61 3.38 7.61 0 1-.09 2.16-.28 3.47-.18 1.31-.6 2.67-1.22 4.04l-48.83 109.12c-1.38 3.26-3.16 5.82-5.36 7.7s-4.91 2.82-8.17 2.82c-4.13 0-7.29-1.1-9.48-3.29s-3.29-4.61-3.29-7.24c0-1.5.31-3.1.94-4.78s1.25-3.16 1.88-4.42l12.21-25.92z"
                  ></path>
                </g>
                <defs>
                  <path
                    id="B"
                    d="M597.34 190.47c0 3.64-.91 6.27-2.72 7.9-1.82 1.62-4.92 2.44-9.3 2.44-3.75 0-6.73-.78-8.92-2.35s-3.29-4.23-3.29-7.99v-3.38c-1.38 1.76-2.91 3.51-4.6 5.26-1.7 1.76-3.76 3.32-6.2 4.7-2.45 1.38-5.3 2.5-8.55 3.38-3.26.87-7.01 1.31-11.27 1.31-9.9 0-17.69-2.6-23.39-7.8s-8.54-12.11-8.54-20.76c0-5.01.85-9.26 2.54-12.77 1.69-3.5 4-6.44 6.95-8.83 2.94-2.38 6.39-4.26 10.33-5.63a76.86 76.86 0 0 1 12.49-3.19c4.75-.87 9.55-1.57 14.37-2.06 4.82-.5 10.05-.94 15.68-1.31v-3.57a20.73 20.73 0 0 0-.75-5.54c-.5-1.82-1.35-3.48-2.54-4.98s-2.85-2.69-4.98-3.56c-2.13-.88-4.76-1.31-7.89-1.31-2.01 0-3.85.12-5.54.37a25.26 25.26 0 0 0-4.88 1.22c-1.57.57-3.19 1.35-4.88 2.35-1.7 1-3.6 2.19-5.73 3.57-1.63 1.12-3.16 2.06-4.6 2.81s-3.23 1.13-5.35 1.13c-2.89 0-5.45-1.1-7.7-3.29s-3.38-4.85-3.38-7.99c0-2.12.87-4.41 2.63-6.86 1.75-2.44 4.41-4.69 7.98-6.76 3.57-2.06 7.95-3.78 13.15-5.17 5.2-1.38 11.3-2.06 18.32-2.06 14.4 0 24.76 2.82 31.08 8.45s9.48 14.4 9.48 26.3v55.97zm-24.42-35.31c-4.76.5-9.29 1.06-13.62 1.69-4.32.63-7.54 1.19-9.67 1.69-6.01 1.25-9.93 3.04-11.74 5.36-1.82 2.32-2.73 4.66-2.73 7.04 0 3.26 1 5.79 3.01 7.61 1.99 1.81 5.44 2.72 10.33 2.72 7.77 0 13.77-1.78 18.04-5.35 4.25-3.57 6.38-8.17 6.38-13.81v-6.95z"
                  ></path>
                </defs>
              </svg>
            </span>
          </b-nav-text>
        </template>
        <template
          v-if="$store.state.auth.settings.attributables.LISABB === 'Y'"
        >
          <b-nav-text>
            <span
              class="lisapay-carts"
              title="Apri Lisabbina in una nuova finestra"
              href="#"
              @click="openLisabbina()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1122.095 266.482"
                height="18"
              >
                <path
                  d="M314.124 77.389a16.78 16.78 0 0 1 3.282-11.169c2.69-2.67 6.402-4.047 10.183-3.779 3.776-.237 7.476 1.136 10.183 3.779a16.11 16.11 0 0 1 3.282 11.33v110.041c.304 4.026-.928 8.017-3.45 11.169a13 13 0 0 1-10.021 3.779c-3.771.205-7.458-1.163-10.183-3.779a15.94 15.94 0 0 1-3.276-11.169V77.389h0zm51.081-.658c-.028-3.788 1.518-7.418 4.269-10.021a13.93 13.93 0 0 1 10.021-4.269c7.846-.17 14.345 6.052 14.515 13.898s-6.052 14.345-13.898 14.515a12.69 12.69 0 0 1-.617 0c-3.781-.003-7.399-1.545-10.021-4.269-2.718-2.557-4.262-6.122-4.269-9.854zm27.755 110.867c.304 4.026-.928 8.017-3.45 11.169a13 13 0 0 1-10.021 3.779c-3.771.205-7.458-1.163-10.183-3.779a15.94 15.94 0 0 1-3.282-11.169V113.36c-.27-4.045.892-8.056 3.282-11.33 2.647-2.736 6.391-4.125 10.183-3.779 3.776-.237 7.476 1.136 10.183 3.779 2.438 3.251 3.605 7.28 3.282 11.33v74.238h.007-.001zm56.168-27.272c-9.815-1.634-19.102-5.575-27.097-11.498-5.358-4.774-8.259-11.722-7.887-18.888-.316-9.457 3.818-18.515 11.169-24.473 8.704-6.447 19.39-9.644 30.205-9.035a56.16 56.16 0 0 1 27.923 6.404c6.395 2.586 10.781 8.562 11.33 15.438a9.92 9.92 0 0 1-3.282 7.719c-2.157 2.08-5.06 3.205-8.055 3.121-4.749-.757-9.157-2.933-12.646-6.242l-2.135-1.644c-1.807-1.345-3.877-2.296-6.075-2.792-2.338-.744-4.775-1.131-7.229-1.148-3.913-.233-7.819.561-11.33 2.302a7.99 7.99 0 0 0-3.759 7.055c.043 2.393 1.358 4.583 3.45 5.746a68.2 68.2 0 0 0 15.767 4.766l8.377 1.806c9.738 1.428 18.983 5.204 26.936 11.001 5.336 4.916 8.172 11.976 7.719 19.217a30.41 30.41 0 0 1-12.156 26.117 58.67 58.67 0 0 1-35.145 9.035c-10.386.37-20.672-2.132-29.729-7.229a20.81 20.81 0 0 1-11.827-17.573c-.203-6.51 4.909-11.953 11.419-12.156a11.29 11.29 0 0 1 .736 0 17.7 17.7 0 0 1 12.156 6.9l2.624 2.953a19.75 19.75 0 0 0 7.383 4.766c3.449 1.09 7.057 1.589 10.672 1.477a23.68 23.68 0 0 0 12.317-2.631 8.15 8.15 0 0 0 4.269-7.384c0-4.269-5.256-7.558-15.606-10.183a.72.72 0 0 1-.49-.161l-10.008-2.786h.004zm154.718-35.474v60.934c.066 1.162.23 2.316.49 3.45l.49 4.927c.127 2.857-1.015 5.624-3.121 7.558a12.42 12.42 0 0 1-8.538 2.792c-4.111.313-8.164-1.117-11.169-3.94-2.694-3.451-3.984-7.794-3.611-12.156a34.8 34.8 0 0 1-13.304 11.988 42.43 42.43 0 0 1-19.217 4.269c-8.314.497-16.46-2.481-22.493-8.223a31.98 31.98 0 0 1-8.055-23.157 31.1 31.1 0 0 1 6.712-21.352c6.375-5.883 14.402-9.667 22.996-10.84 3.45-.671 8.538-1.477 15.438-2.302 4.272-.323 8.505-1.037 12.646-2.134 1.484-.509 2.719-1.565 3.45-2.953.706-1.544 1.043-3.23.987-4.927.333-3.366-1.096-6.666-3.779-8.726-3.865-2.102-8.264-3.015-12.646-2.624-1.484.015-2.966.125-4.437.329-1.399.191-2.775.522-4.108.987-2.484.76-4.774 2.049-6.712 3.779l-3.121 3.121a17.41 17.41 0 0 1-11.988 6.9 10.07 10.07 0 0 1-7.719-3.121c-2.086-2.081-3.216-4.935-3.121-7.88.528-7.499 4.955-14.171 11.659-17.573 8.575-5.278 18.518-7.907 28.581-7.558a60.15 60.15 0 0 1 32.353 7.229c7.384 4.452 11.735 12.591 11.337 21.204h0zm-25.788 26.446a83.35 83.35 0 0 1-15.277 4.927 86.14 86.14 0 0 0-8.867 1.973 21.19 21.19 0 0 0-9.854 5.095 12.27 12.27 0 0 0-2.792 8.377c-.145 3.375 1.244 6.634 3.779 8.867a15.32 15.32 0 0 0 10.35 3.282 22.15 22.15 0 0 0 16.425-6.242 22.95 22.95 0 0 0 6.242-16.781l-.007-9.498h.001zM133.24 0C59.654 0 0 59.654 0 133.241s59.654 133.241 133.241 133.241 133.241-59.654 133.241-133.241S206.827 0 133.24 0zm52.905 208.666H94.219c-12.264 0-22.205-9.942-22.205-22.205V70.179c0-12.263 9.941-22.205 22.205-22.205s22.205 9.941 22.205 22.205v94.077h69.721c12.262.003 22.202 9.943 22.205 22.205s-9.941 22.205-22.205 22.205h0z"
                ></path>
                <circle cx="863.583" cy="76.831" r="14.393"></circle>
                <path
                  d="M931.796 117.892a.21.21 0 0 0 .294.037c.015-.012.029-.025.04-.041 8.345-11.275 19.425-17.529 33.789-17.362 6.073.068 11.783 1.042 17.142 3.634 11.36 5.49 16.761 16.694 17.394 28.943.033.657.055 3.027.064 7.111l-.011 48.965c-.007 3.262-.196 5.561-.565 6.898-1.29 4.653-4.629 7.415-10.02 8.285-9.7 1.568-17.071-2.706-17.071-13.216l-.007-50.046c-.004-9.903-5.927-17.174-15.961-17.81-10.489-.665-20.072 6.848-22.088 17.131-.284 1.463-.428 3.821-.43 7.076l-.018 43.383c0 6.023-2.204 11.35-8.395 13.085-3.577 1.006-8.057.956-11.687-.27-2.901-.981-5.074-3.061-6.358-5.892-.801-1.771-1.203-3.545-1.205-5.323l-.004-78.313c.004-4.679 1.191-9.206 5.237-11.791 3.221-2.055 7.63-2.297 11.396-1.429 7.886 1.82 8.686 10.112 8.334 16.729-.002.036.007.068.028.096l.1.121h.002zm-55.779 80.177c-2.283 5.106-7.591 6.602-12.669 6.598-5.017-.007-9.771-1.677-12.164-6.515-.941-1.905-1.413-3.841-1.415-5.809l.004-77.769c.002-3.44.184-5.838.544-7.192 2.247-8.471 11.407-10.129 18.735-8.112 5.341 1.47 8.352 6.526 8.356 11.951l.004 77.117c-.004 4.096.014 6.58-1.394 9.731h-.001zm217.137-9.302l-3.438 3.303c-7.355 6.907-15.967 10.938-25.835 12.093-9.991 1.17-19.46.427-27.933-5.522-5.744-4.032-9.42-9.334-11.03-15.904-1.312-5.355-.942-11.584.665-16.836 4.274-13.984 19.481-19.03 32.46-20.722l21.682-2.517c6.82-.693 12.544-3.033 11.805-11.14-.9-9.853-13.451-11.083-21.049-10.397-6.201.562-11.565 3.129-16.093 7.702-2.293 2.318-5.188 5.22-7.936 6.397-7.392 3.168-16.669-2.073-16.054-10.66.473-6.603 6.123-12.463 11.538-15.833 8.292-5.156 17.981-7.542 27.652-8.082 17.113-.956 45.548 1.806 49.313 23.492.258 1.493.386 3.857.384 7.09l-.025 44.894c0 3.883.333 7.054.999 9.515.786 2.894 2.045 6.528 1.806 9.248-.491 5.636-5.803 9.255-11.147 9.693-10.567.868-17.135-5.252-17.544-15.727-.009-.194-.083-.223-.22-.085v-.002zm-19.648-2.945c9.778-2.027 18.07-9.262 18.091-19.833l.021-10.201c0-.159-.063-.19-.188-.092-1.887 1.467-3.832 2.447-5.835 2.941-4.378 1.079-9.385 1.957-15.019 2.635-5.902.708-14.464 2.418-17.551 8.292-1.817 3.456-1.65 8.238.718 11.371 4.388 5.814 13.284 6.23 19.762 4.889v-.002z"
                ></path>
                <path
                  d="M646.489 190.711c.162 3.339-1.024 6.603-3.291 9.059a12.6 12.6 0 0 1-9.221 3.291 13.03 13.03 0 0 1-10.048-3.789c-2.398-3.221-3.566-7.193-3.291-11.199V77.576a17.01 17.01 0 0 1 3.291-11.36c5.624-5.036 14.136-5.036 19.76 0 2.42 3.272 3.588 7.302 3.291 11.36v35.239c3.063-5.083 7.448-9.24 12.687-12.027 5.308-2.676 11.184-4.031 17.129-3.951 11.857-.111 23.029 5.537 29.97 15.149 8.171 11.39 12.287 25.191 11.69 39.197.625 13.907-3.497 27.613-11.69 38.867a36.47 36.47 0 0 1-30.286 14.658c-5.924.206-11.79-1.219-16.96-4.119a39.13 39.13 0 0 1-13.01-13.01l-.02 3.129v.002h0zm23.22-70.485c-6.618-.345-12.956 2.697-16.826 8.077a47.68 47.68 0 0 0 0 45.449c3.91 5.187 10.144 8.088 16.63 7.74a18.6 18.6 0 0 0 16.301-8.077c4.303-6.946 6.318-15.067 5.761-23.219.411-7.746-1.666-15.42-5.93-21.9-3.567-5.257-9.59-8.304-15.938-8.063v-.007h.002z"
                ></path>
                <path
                  d="M759.468 190.711c.162 3.339-1.024 6.603-3.291 9.059a12.6 12.6 0 0 1-9.221 3.291 13.03 13.03 0 0 1-10.048-3.789c-2.398-3.221-3.566-7.193-3.291-11.199V77.576a17.01 17.01 0 0 1 3.291-11.36c5.624-5.036 14.136-5.036 19.76 0 2.42 3.272 3.588 7.302 3.291 11.36v35.239c3.063-5.083 7.448-9.24 12.687-12.027 5.308-2.676 11.184-4.031 17.129-3.951 11.857-.111 23.029 5.537 29.97 15.149 8.171 11.39 12.287 25.191 11.69 39.197.625 13.907-3.497 27.613-11.69 38.867a36.47 36.47 0 0 1-30.286 14.658c-5.924.206-11.79-1.219-16.96-4.119a39.13 39.13 0 0 1-13.01-13.01l-.02 3.129v.002h0zm23.22-70.485c-6.618-.345-12.956 2.697-16.826 8.077a47.68 47.68 0 0 0 0 45.449c3.91 5.187 10.144 8.088 16.63 7.74a18.6 18.6 0 0 0 16.301-8.077c4.303-6.946 6.318-15.067 5.761-23.219.411-7.746-1.666-15.42-5.93-21.9-3.567-5.257-9.59-8.304-15.938-8.063v-.007h.002z"
                ></path>
              </svg>
            </span>
          </b-nav-text>
        </template>
        <b-nav-text
          :class="`notifications-wrapper${
            notifications ? ' has-notifications' : ''
          }`"
          @click="onClickNotificationsDrawer()"
          @keyup="onKeyUpNotificationsDrawer"
          tabindex="0"
        >
          <b-overlay :show="loadingNotifications">
            <div
              class="d-flex justify-content-center align-items-center"
              v-show="!loadingNotifications"
            >
              <!-- <b-icon icon="bell-fill" font-scale="1"></b-icon> -->
              <base-icon name="bell" width="16" height="16"></base-icon>
            </div>
            <template #overlay>
              <div class="text-center">
                <div class="custom-loader custom-loader--small"></div>
                <!-- <base-icon name="loading" width="18" height="18" /> -->
              </div>
            </template>
          </b-overlay>
        </b-nav-text>
        <b-nav-text
          :class="`reports-wrapper${reports ? ' has-reports' : ''}`"
          @click="onClickReportsDrawer()"
          @keyup="onKeyUpReportsDrawer"
          tabindex="0"
        >
          <b-overlay :show="loadingReports">
            <div v-show="!loadingReports">
              <!-- <b-icon icon="cloud-download" font-scale="1"></b-icon> -->
              <base-icon
                name="download"
                width="18"
                height="18"
                style="translate: 0 -1px"
              />
            </div>
            <template #overlay>
              <div class="text-center" style="color: #333">
                <div class="custom-loader custom-loader--small"></div>
                <!-- <base-icon name="loading" width="18" height="18" /> -->
              </div>
            </template>
          </b-overlay>
        </b-nav-text>
        <b-nav-item-dropdown right class="mr-0" v-if="isLogged">
          <template slot="button-content">
            <!-- <b class="mr-3">Agenzia: {{ settings.formatted_title}}</b> -->
            <!-- <b-avatar variant="light"></b-avatar> -->
            <span class="user-wrapper">
              <b-avatar size="sm" variant="light" class="mr-1"></b-avatar>
              <span class="mr-auto"
                >{{ user.username }} -
                <span class="agency-name">{{ agencyName }}</span></span
              >
            </span>
          </template>
          <b-dropdown-item @click="openChangePwdModal()"
            >Cambia Password
          </b-dropdown-item>
          <b-dropdown-item @click="signoff()">Esci</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
    <div>
      <search-results-modal
        :results="results"
        :term="searchedTerm"
        @close="onClose"
        @hidden="results = []"
      />
    </div>
    <div>
      <change-pwd-modal title="Cambia password" />
    </div>
  </div>
</template>
<script>
import BaseIcon from "@/components/BaseIcon";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import { mapGetters, mapActions } from "vuex";
import Burger from "@/components/Burger.vue";
import SearchResultsModal from "@/components/modals/searchResults";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { canVerb } from "@/utils/permissions";
import { isPoldo } from "@/utils/theme";
import ChangePwdModal from "@/components/modals/changePwd";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import LisawebSwitchMixin from "../mixins/LisawebSwitchMixin";

export default {
  mixins: [StorageGetterMixin, LisawebSwitchMixin],
  components: {
    Breadcrumbs,
    Burger,
    SearchResultsModal,
    ChangePwdModal,
    BaseIcon,
  },
  props: {
    reports: {
      type: Number,
      default() {
        return 0;
      },
    },
    notifications: {
      type: Number,
      default() {
        return 0;
      },
    },
    loadingNotifications: {
      type: Boolean,
      default: false,
    },
    loadingReports: {
      type: Boolean,
      default: false,
    },
    pTitle: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  // props: ["pTitle"],
  data() {
    return {
      something: "",
      searchOpen: false,
      isLoading: false,
      breadcrumblist: null,
      clearedBreadcrumbList: null,
      // Risposta della ricerca rapida, congelata (non reattiva) e svuotata
      // alla chiusura della modale: con molti risultati pesa decine di MB.
      results: [],
      searchedTerm: "",
      codeAgency: /(?:www.)?(\w+)(\..*)+/.exec(window.location.hostname)[1],
    };
  },
  watch: {
    "$store.state.queue.items": {
      deep: true,
      handler() {
        this.breadcrumblist = this.getQueue();
        this.clearedBreadcrumbList = this.breadcrumblist
          ? [...this.breadcrumblist.slice(1, this.breadcrumblist.length)]
          : [];
      },
    },
    loadingNotifications: function (newVal, oldVal) {
      // watch it
      console.log(
        `Prop "loadingNotifications" changed: , ${newVal}, | was: , ${oldVal}`,
      );
    },
    loadingReports: function (newVal, oldVal) {
      // watch it
      console.log(
        `Prop "loadingReports" changed: , ${newVal}, | was: , ${oldVal}`,
      );
    },
    // //Watch queue-store changes
    // "$store.state.queue.items": {
    //   //If you want to watch nested elements, you need to use the deep flag in your watcher
    //   deep: true,
    //   handler() {
    //     this.breadcrumblist = this.getQueue();
    //     // let len = this.breadcrumblist.length;
    //     // this.pageTitle =
    //     //   len === 1 ? { text: "Dashboard" } : this.breadcrumblist[len - 1];
    //     this.clearedBreadcrumbList = this.breadcrumblist
    //       ? [...this.breadcrumblist.slice(1, this.breadcrumblist.length)]
    //       : [];
    //   },
    // },
  },
  methods: {
    canVerb,
    onOpenMenuDrawer() {
      this.$parent.$emit("openMenuDrawer");
    },
    openLisaPay() {
      if (!this.lisapayConfig.base_url || !this.lisapayConfig.realm) {
        this.$showSnackbar({
          preset: "error",
          text: "Configurazione Lisapay non disponibile.",
        });
        return;
      }
      const windowFeatures =
        "popup=1,left=10,width=1000,height=1000,noopener,noreferrer";
      window.open(
        `https://${this.lisapayConfig.base_url}/history?lwAgency=${this.codeAgency}&lwRealm=${this.lisapayConfig.realm}&lwToken=${this.$store.state.auth.token}`,
        "Lisapay",
        windowFeatures,
      );
    },
    openLisabbina() {
      if (!this.lisabbinaConfig.base_url || !this.lisabbinaConfig.realm) {
        this.$showSnackbar({
          preset: "error",
          text: "Configurazione Lisabbina non disponibile.",
        });
        return;
      }
      const windowFeatures =
        "popup=1,left=10,width=1000,height=1000,noopener,noreferrer";
      window.open(
        `https://${this.lisabbinaConfig.base_url}?realm=${this.lisabbinaConfig.realm}&agency=${this.codeAgency}&token=${this.$store.state.auth.token}`,
        "Lisabbina",
        windowFeatures,
      );
    },
    onKeyUpNotificationsDrawer(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.code === "Escape") {
        // Emit event to App.vue, skipping CustomHeader.vue
        this.$parent.$emit("closeKeyUpNotificationsDrawer");
        return;
      }
      if (["Space", "Enter"].includes(e.code))
        this.onClickNotificationsDrawer();
    },
    onKeyUpReportsDrawer(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.code === "Escape") {
        // Emit event to App.vue, skipping CustomHeader.vue
        this.$parent.$emit("closeKeyUpReportsDrawer");
        return;
      }
      if (["Space", "Enter"].includes(e.code)) this.onClickReportsDrawer();
    },
    onClickNotificationsDrawer() {
      // Emit event to App.vue, skipping CustomHeader.vue
      this.$parent.$emit("openNotificationsDrawer");
    },
    onClickReportsDrawer() {
      // Emit event to App.vue, skipping CustomHeader.vue
      this.$parent.$emit("openReportsDrawer");
    },
    openSearch() {
      this.searchOpen = true;
      this.$nextTick(() => this.$refs.searchInput?.focus());
    },
    // Click fuori dalla ricerca: torna l'icona (la ricerca in corso continua).
    onDocumentMousedown(event) {
      const box = this.$refs.headerSearch;
      if (this.searchOpen && box && !box.contains(event.target)) {
        this.searchOpen = false;
      }
    },
    getSomething(event) {
      if (this.isLoading) {
        this.$showSnackbar({
          preset: "info",
          text: "Un altra ricerca è in corso. Attendere...",
          duration: 1000,
        });
        return;
      }
      if (event.which === 13) {
        this.onFind();
      }
    },
    getUniqueBy(arr, prop) {
      const set = new Set();
      return arr.filter((o) => !set.has(o[prop]) && set.add(o[prop]));
    },
    onFind() {
      /* */
      console.log("onFind");
      const path = "auth/";
      const resources = [];
      if (!this.hasLoadedResource("councils"))
        resources.push(
          this.$store
            .dispatch(`${path}councils`)
            .then(() => {})
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({ preset: "error", text: errMsg });
            }),
        );
      if (!this.hasLoadedResource("provinces"))
        resources.push(
          this.$store
            .dispatch(`${path}provinces`)
            .then(() => {})
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({ preset: "error", text: errMsg });
            }),
        );
      if (!this.hasLoadedResource("countries"))
        resources.push(
          this.$store
            .dispatch(`${path}countries`)
            .then(() => {})
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({ preset: "error", text: errMsg });
            }),
        );
      if (resources.length) {
        this.getResources(resources)
          .then(() => {})
          .catch((error) => {
            console.log("One or more promises crashed... :|");
            this.onFailure(error);
          })
          .finally(() => {
            this.isLoading = false;
            this.onActualFind();
          });
      } else {
        this.isLoading = false;
        this.onActualFind();
      }
      /* */
    },
    onActualFind() {
      console.log("onActualFind");
      if (this.something.trim()) {
        if (this.something.trim().length < 3) {
          this.$showSnackbar({
            preset: "error",
            text: "Digitare almeno 3 caratteri",
          });
          return;
        }
        // NOTE: inviare tutti i termini separati da virgola
        // let term = this.something.replace(/(\s)+/g, ",");
        let term = this.something;
        const IndexRepository = RepositoryFactory.get("index");
        this.isLoading = true;
        IndexRepository.tags(term)
          .then((response) => {
            this.searchedTerm = term;
            this.results = Object.freeze(response.data.data);
            this.$bvModal.show("searchResults");
            if (response.data.total > response.data.data.length) {
              this.$showSnackbar({
                preset: "info",
                text: `Mostrati i primi ${response.data.data.length} termini su ${response.data.total}: affinare la ricerca`,
              });
            }
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            // this.isLoading = false;
            this.$showSnackbar({
              preset: "error",
              text: errMsg,
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$showSnackbar({
          preset: "error",
          text: `Digitare un criterio.`,
          duration: 1000,
        });
      }
    },
    onClose() {
      // clear the search criteria...
      this.something = null;
    },
    signoff() {
      console.info("signing off...");
      this.$emit("signoff", null);
    },
    openChangePwdModal() {
      this.$bvModal.show("changePwd");
    },
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapActions("queue", [/* "popQueue", "pushQueue", */ "emptyQueue"]),
    ...mapGetters("queue", ["getQueue"]),
  },
  computed: {
    ...mapGetters("auth", [
      "isLogged",
      "user",
      "lisapayConfig",
      "lisabbinaConfig",
    ]),
    computeEnv() {
      return process.env.VUE_APP_TEST;
    },
    computePd() {
      return isPoldo() ? "true" : "false";
    },
    agencyName() {
      return this.$store.state.auth.settings.formatted_title;
    },
    // cliVer() {
    //   return process.env.VUE_APP_VERSION || "0";
    // },
  },
  created() {
    this.$parent.$emit("loadNotifications");
  },
  mounted() {
    document.addEventListener("mousedown", this.onDocumentMousedown);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.onDocumentMousedown);
  },
};
</script>
<style lang="scss" scoped>
.left-header {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.user-wrapper {
  white-space: nowrap;
}

.agency-name {
  font-size: var(--font-size-xs);
  font-weight: 500;
}

nav.bg-lisaweb-navbar {
  position: relative;
  padding-bottom: calc(0.5rem + 0.25rem);
  // margin-bottom: 0.75rem;
  // &:after {
  //   position: absolute;
  //   bottom: 0;
  //   left: 12px;
  //   display: block;
  //   width: calc(100% - 12px);
  //   height: 1px;
  //   content: "";
  //   background-color: #dbdbdb;
  // }
}

.logo-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  transition:
    opacity 0.15s ease-out,
    visibility 0s;

  // Con la ricerca aperta il logo sfuma e poi diventa invisibile (resta al
  // suo posto).
  &.is-hidden {
    opacity: 0;
    visibility: hidden;
    transition:
      opacity 0.15s ease-out,
      visibility 0s linear 0.15s;
  }
}

.logo {
  vertical-align: baseline;
}

.page-title {
  color: var(--color-text);
  margin: 0 50px 0 0;
  font-size: var(--font-size-lg);
  font-weight: 500;
}

body .navbar {
  height: auto;
  display: flex;
  align-items: center;
  gap: 10px;
}

@media (min-width: 999px) {
  body .navbar {
    height: auto;
  }
}

.page-title {
  position: relative;
  top: 1px;
}

// :deep(.dropdown-menu) {
//   top: 90% !important;
//   padding: 0.25rem 0 !important;
// }

:deep(.nav-item) {
  display: flex;
  justify-content: center;
  align-items: center;
}

.search-bar-wrapper {
  border-radius: var(--radius-pill);
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.12);
}

// Ricerca chiusa: un'icona come la campanella delle notifiche.
.header-search {
  margin-right: 0.5rem;
}

.header-search__toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: white;
  color: var(--color-text);
  cursor: pointer;

  .b-icon {
    width: 12px;
    height: 12px;
  }
}

// L'icona resta al suo posto (invisibile) mentre la barra è aperta: le
// altre voci della testata non si spostano.
.header-search__toggle.is-hidden {
  visibility: hidden;
}

// Barra aperta: larga, al centro della testata, sopra il logo. Il
// riferimento è la navbar (position: relative), come per .logo-wrapper.
.header-search__panel {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  // Lascia libero ai lati lo spazio delle icone a destra (notifiche,
  // utente): su schermi stretti la barra si accorcia.
  width: min(640px, max(320px, calc(100% - 480px)));
  transform: translate(-50%, -50%);
}

// Il campo occupa tutta la larghezza della barra (.form-inline non lo
// allarga da sé).
.header-search__panel .form-inline,
.header-search__panel .search-bar {
  width: 100%;
}

.header-search__hint {
  position: absolute;
  top: 100%;
  right: 18px;
  margin: 6px 0 0;
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
  white-space: nowrap;
}

// Apertura: la barra si allarga da destra, dove c'era la lente; il
// suggerimento compare subito dopo. Chiusura più rapida, al contrario.
.header-search-enter-active {
  transition:
    clip-path 0.22s cubic-bezier(0.2, 0.8, 0.2, 1),
    opacity 0.15s ease-out;

  .header-search__hint {
    transition: opacity 0.15s ease-out 0.15s;
  }
}

.header-search-leave-active {
  transition:
    clip-path 0.15s ease-in,
    opacity 0.12s ease-in;
}

.header-search-enter,
.header-search-leave-to {
  clip-path: inset(0 0 0 100% round 999px);
  opacity: 0;

  .header-search__hint {
    opacity: 0;
  }
}

.header-search-enter-to,
.header-search-leave {
  // Margini negativi: l'ombra della barra e il suggerimento sotto non
  // vengono tagliati.
  clip-path: inset(-20px -20px -40px -20px);
}

@media (prefers-reduced-motion: reduce) {
  .header-search-enter-active,
  .header-search-leave-active {
    transition: opacity 0.15s ease-out;
  }

  .header-search-enter,
  .header-search-leave-to,
  .header-search-enter-to,
  .header-search-leave {
    clip-path: none;
  }
}

:deep(.navbar > .navbar-nav:last-of-type .nav-item:last-of-type a) {
  margin-right: -0.5rem;
}

.search-bar .search-bar > .form-control.form-control-sm {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}

.search-bar {
  background: #fff !important;
  padding-right: 16px;
  padding-left: 12px;
  border-radius: var(--radius-pill);
  // same width as the focused state, so focus does not shift the navbar
  border: 2px solid transparent;
}

.search-bar > .form-control.form-control-sm {
  color: var(--color-text) !important;
}

.search-bar .form-control {
  background: transparent !important;
  box-shadow: none !important;
  border: 0 !important;
  width: 100%;
  font-size: var(--font-size-md);
}

.search-bar.input-group {
  flex-wrap: nowrap;
}

.search-bar input[type="search"] {
  height: 38px;

  &::placeholder {
    font-size: var(--font-size-md);
  }
}

.search-bar .input-group-text {
  background: transparent;
  color: var(--color-text);
  border: none;
  padding: 0 !important;
}

.search-bar .input-group-text .b-icon.bi {
  width: 18px;
  height: 18px;
}

.search-bar:has(input[type="search"]:focus) {
  border: 2px solid var(--lisaweb) !important;
  outline: none;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: var(--color-text-muted) !important;
  font-size: var(--font-size-sm);
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: var(--color-text-muted) !important;
  font-size: var(--font-size-sm);
  opacity: 1; /* Firefox */
}

/* clears the ‘X’ from Internet Explorer */
input[type="search"]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}

input[type="search"]::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/* clears the ‘X’ from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}

:deep(.version) {
  // position: absolute;
  // top: 2px;
  // left: 130px;
  font-size: smaller;
}

input:placeholder-shown + div {
  pointer-events: none;
  touch-action: none;
  cursor: not-allowed;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

:deep(.b-nav-dropdown .dropdown-menu) {
  padding-inline: 0;
  min-width: 0;
}

:deep(.b-nav-dropdown a.dropdown-item) {
  font-size: var(--font-size-sm);
  text-align: right;
  padding: 0.25rem 1rem;
}

.lisapay-carts {
  cursor: pointer;
}
</style>
